import { extendTheme } from 'native-base';

export const { components } = extendTheme({
  components: {
    Text: {
      baseStyle: {
        fontFamily: 'Poppins',
      },
      sizes: {
        xl: {
          fontSize: '64px',
        },
        lg: {
          fontSize: '32px',
        },
        md: {
          fontSize: '16px',
        },
        sm: {
          fontSize: '12px',
        },
      },
    },
    Checkbox: {
      defaultProps: {
        _checked: {
          borderColor: 'singletons.darkText',
          bgColor: 'singletons.darkText',
        },
        _unchecked: {
          borderColor: 'singletons.darkText',
          bgColor: 'transparent',
        },
        iconColor: 'white',
      },
    },
    FormControlLabel: {
      defaultProps: {
        mb: 2,
        _text: {
          color: 'grey.600',
        },
      },
    },
    Input: {
      defaultProps: {
        p: 4,
      },
      baseStyle: {
        fontFamily: 'Poppins',
        borderRadius: '12px',
        focusOutlineColor: 'singletons.black',
        _focus: {
          style: {
            borderColors: 'singletons.black',
          },
        },
      },
    },
    Link: {
      baseStyle: {
        color: 'primary.400',
        fontFamily: 'Poppins',
      },
    },
    Flex: {
      defaultProps: {
        flexShrink: 1,
      },
    },
    Box: {
      defaultProps: {
        flexShrink: 1,
      },
    },
    Button: {
      variants: {
        primary: () => ({
          bg: 'singletons.black',
          borderRadius: '12px',
          _text: {
            color: 'singletons.white',
          },
        }),
        link: () => ({
          _text: {
            color: 'singletons.black',
          },
        }),
        outline: () => ({
          bg: 'transparent',
          borderRadius: '12px',
          borderColor: 'singletons.black',
          _text: {
            color: 'singletons.black',
          },
          _pressed: { bg: 'transparent', opacity: 0.6 },
        }),
        ghost: () => ({
          _text: {
            color: 'singletons.black',
          },
          _pressed: { bg: 'transparent', opacity: 0.6 },
        }),
      },
      defaultProps: {
        h: '37px',
        w: '100%',
        _text: {
          fontFamily: 'Poppins',
        },
        variant: 'primary',
        _icon: {
          color: 'singletons.white',
        },
      },
    },
  },
});
